import {BaseService} from './Core/BaseService';
import {BaseSearchableService} from "./Core/BaseSearchableService";

class ContextNodeActivityService extends BaseSearchableService {
    get Url() { return super.Url + "/contextNodeActivities"; }

    Get(contextNodeId, activityTypeIds = null, includeSystemActivities = true, lastActivityId = undefined, startDate = undefined, endDate = undefined) {
        return this.SendRequest(BaseService.GET, {
            contextNodeId,
            activityTypeIds: activityTypeIds?.length ? activityTypeIds : undefined,
            includeSystemActivities: includeSystemActivities ? 1 : 0,
            lastActivityId,
            // day-granularity Y-m-d created bounds, both ends inclusive
            start: startDate,
            end: endDate,
        }, null);
    }
}

export const service = new ContextNodeActivityService();

